
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.693 5v18.333H15.248a.222.222 0 01-.08-.429v-.002c1.977-.757 3.835-2.577 5.368-5.94l1.706-3.746C25.322 6.456 27.046 5 31.693 5zM18.217 2.096v.002c-1.976.758-3.833 2.578-5.366 5.94l-1.707 3.746C8.064 18.544 6.341 20 1.694 20V1.667h16.444a.222.222 0 01.08.429zM.027 25H33.36V0H.027v25z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    